
import React, { useState } from 'react';
import { UserProfile, Meeting } from '../types';

interface MeetingModalProps {
  targetUser: UserProfile;
  currentUser?: UserProfile | null;
  onClose: () => void;
  onSubmit: (data: { date: string, time: string, location: string, message: string, format: string }) => void | Promise<void>;
  initialData?: Meeting;
}

export function MeetingModal({ targetUser, currentUser, onClose, onSubmit, initialData }: MeetingModalProps) {
  const [date, setDate] = useState(initialData?.meeting_date || '');
  const [hour, setHour] = useState(initialData?.meeting_time.split(':')[0] || '10');
  const [minute, setMinute] = useState(initialData?.meeting_time.split(':')[1] || '00');
  const [location, setLocation] = useState(initialData?.location || '');
  const [format, setFormat] = useState(initialData?.format || 'offline');
  const [message, setMessage] = useState(initialData?.message || `Привет, ${targetUser.name}! Давай встретимся, обсудим ${targetUser.activitySphere}.`);

  const hours = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  const minutes = ['00', '15', '30', '45'];

  const labelClasses = "block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2";
  const inputClasses = "w-full px-5 py-4 bg-gray-50 border border-gray-100 rounded-2xl outline-none focus:ring-2 focus:ring-red-500 font-medium";

  const handleFormSubmit = () => {
    if (!date || !location) return alert('Заполните дату и место!');
    onSubmit({
      date,
      time: `${hour}:${minute}`,
      location,
      message,
      format
    });
  };

  return (
    <div className="bg-white rounded-[3rem] p-10 max-w-lg w-full shadow-2xl animate-fadeIn relative" onClick={e => e.stopPropagation()}>
      <h3 className="text-3xl font-black text-gray-900 mb-2 tracking-tighter uppercase">
        {initialData ? 'Изменить встречу' : 'Приглашение на кофе'}
      </h3>
      <p className="text-sm text-gray-500 mb-8 italic">Вы общаетесь с <span className="text-red-600 font-bold">{targetUser.name}</span></p>

      <div className="space-y-6">
        <div className="flex bg-gray-100 p-1 rounded-2xl">
          <button onClick={() => setFormat('offline')} className={`flex-1 py-3 rounded-xl text-[10px] font-black uppercase transition-all ${format === 'offline' ? 'bg-white shadow-sm text-black' : 'text-gray-400'}`}>📍 Лично</button>
          <button onClick={() => setFormat('online')} className={`flex-1 py-3 rounded-xl text-[10px] font-black uppercase transition-all ${format === 'online' ? 'bg-white shadow-sm text-black' : 'text-gray-400'}`}>💻 Онлайн</button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className={labelClasses}>Дата</label>
            <input type="date" required className={inputClasses} value={date} onChange={e => setDate(e.target.value)} />
          </div>
          <div>
            <label className={labelClasses}>Время</label>
            <div className="flex gap-2">
              <select className={inputClasses} value={hour} onChange={e => setHour(e.target.value)}>
                {hours.map(h => <option key={h} value={h}>{h}</option>)}
              </select>
              <select className={inputClasses} value={minute} onChange={e => setMinute(e.target.value)}>
                {minutes.map(m => <option key={m} value={m}>{m}</option>)}
              </select>
            </div>
          </div>
        </div>
        <div>
          <label className={labelClasses}>{format === 'offline' ? 'Место встречи' : 'Ссылка на звонок'}</label>
          <input type="text" placeholder={format === 'offline' ? "Кафе или адрес" : "Zoom/Google Meet"} required className={inputClasses} value={location} onChange={e => setLocation(e.target.value)} />
        </div>
        <div>
          <label className={labelClasses}>Сообщение / Мой ответ</label>
          <textarea className={`${inputClasses} h-24 resize-none`} value={message} onChange={e => setMessage(e.target.value)} />
        </div>
        
        <div className="flex gap-4 pt-4">
          <button onClick={handleFormSubmit} className="flex-1 py-5 bg-black text-white font-black rounded-2xl uppercase tracking-widest text-xs hover:bg-red-600 transition-all shadow-lg">
            {initialData?.status === 'pending' && initialData.inviteeId === currentUser?.id ? 'ПОДТВЕРДИТЬ' : 'СОХРАНИТЬ'}
          </button>
          {initialData && (
            <button onClick={() => {
              const reason = prompt('Укажите причину отмены:');
              if (reason) handleFormSubmit(); // Здесь можно добавить отдельную логику для отмены
            }} className="px-6 py-5 bg-red-50 text-red-600 font-black rounded-2xl uppercase text-[10px] tracking-widest">ОТМЕНИТЬ</button>
          )}
          <button onClick={onClose} className="px-8 py-5 border-2 border-gray-900 text-gray-900 font-black rounded-2xl uppercase tracking-widest text-xs">ОТМЕНА</button>
        </div>
      </div>
    </div>
  );
}
